module.exports = __webpack_public_path__ + "img/equipos-moviles-superior.db5502aa.jpg";